import { render, staticRenderFns } from "./forfeit.vue?vue&type=template&id=72ac84e2&"
import script from "./forfeit.vue?vue&type=script&lang=js&"
export * from "./forfeit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports